export const QUOTES_COLUMNS = {
	name: "name",
	status: "status",
	quoteLink: "quote_link",
} as const;
